import { z } from 'zod';
import { componentStyleSchema } from '../component-catalog.js';
const commonOptionals = {
    queryConfig: z.record(z.string(), z.unknown()).optional(),
    minimized: z.boolean().optional(),
    displayConfig: z.record(z.string(), z.unknown()).optional(),
    annotations: z.array(z.record(z.string(), z.unknown())).optional(),
    style: componentStyleSchema.optional(),
};
const propsSchema = z
    .object({
    sourceDataset: z.string(),
    mapping: z
        .object({
        value: z.string(),
        min: z.string().optional(),
        max: z.string().optional(),
    })
        .strict(),
    ...commonOptionals,
})
    .strict();
export const gaugeChartDefinition = {
    type: 'GaugeChart',
    category: 'data',
    propsSchema,
    isDataBacked: true,
    columnRefManifest: ['value', 'min', 'max'],
    needsMeasuredDims: true,
    defaultMinHeight: 200,
    description: 'Gauge chart over a dataset. Props: sourceDataset (required), mapping ({ value: string, min?: string, max?: string }).',
};
//# sourceMappingURL=GaugeChart.js.map